// NPM Imports
import React from "react";

// Component Imports
import AddOptionToClauseBtn from "./AddOptionToClauseBtn";
import AddOptionToClauseBtnUpgrade from "./AddOptionToClauseBtnUpgrade";
import { FeatureGating } from "../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function(props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS}
      altComponent={
        <AddOptionToClauseBtnUpgrade
          toggleUpgradePopup={props.toggleUpgradePopup}
        />
      }>
      <AddOptionToClauseBtn {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/components/DocumentItems/AddOptionToClauseBtn/index.js